const TAG_FIELDS = {
  ID: {api_name: 'id', required: false, label: 'id', display_label: 'id'},
  COMPANY_NAME: {api_name: 'companyName', required: true, label: 'Company Name', display_label: 'Company Name'},
  TAG_NAME: {api_name: 'tagName', required: true, label: 'Tag Name', display_label: 'Tag Name'},
  CREATED_BY: {api_name: 'createdBy', required: true, label: 'Created By', display_label: 'Created By'},
  REMINDER_DATE: {api_name: 'reminderDate', required: false, label: 'Reminder Date', display_label: 'Reminder Date'},
  CREATED_DATE: {api_name: 'createdDate', required: false, label: 'Created Date', display_label: 'Created Date'},
  CREATED_AT: {api_name: 'createdAt', required: false, label: 'Created On', display_label: 'Created On'},
}
export {TAG_FIELDS};
